import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import {
  IAllApplication,
  IHrRequestFormDialog,
  IUserOffboarding,
  IUserOnboarding,
} from "./allApplications.types";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { uploadFile } from "../../features/FileUpload/utils";
import { makeApiCall } from "../../helpers/postRequest";

export const FETCH_APPLICATIONS_LIST_PROGRESS =
  "FETCH_APPLICATIONS_LIST_PROGRESS";
export const FETCH_APPLICATIONS_LIST_SUCCESS =
  "FETCH_APPLICATIONS_LIST_SUCCESS";
export const FETCH_APPLICATIONS_LIST_FAILED = "FETCH_APPLICATIONS_LIST_FAILED";

export const fetchApplicationsListProgress = () =>
  action(FETCH_APPLICATIONS_LIST_PROGRESS);
export const fetchApplicationsListSuccess = (
  list: IAllApplication[],
  totalRecords: number
) => action(FETCH_APPLICATIONS_LIST_SUCCESS, { list, totalRecords });
export const fetchApplicationsListFailed = () =>
  action(FETCH_APPLICATIONS_LIST_FAILED);

export const fetchApplicationsListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchApplicationsListProgress());

      let finalUrl = `/hr/get-hr-application-form?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (searchValue.length > 0) {
        finalUrl = `/hr/get-hr-application-form?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      const res = await api.get(finalUrl);
      const data: IAllApplication[] = res.data.data;
      const totalRecords = res.data.totalRecords;
      dispatch(fetchApplicationsListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchApplicationsListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const FETCH_APPLICATION_PROGRESS = "FETCH_APPLICATION_PROGRESS";
export const FETCH_APPLICATION_SUCCESS = "FETCH_APPLICATION_SUCCESS";
export const FETCH_APPLICATION_FAILED = "FETCH_APPLICATION_FAILED";
export const UPSERT_APPLICATION = "UPSERT_APPLICATION";

export const fetchApplicationProgress = () =>
  action(FETCH_APPLICATION_PROGRESS);
export const fetchApplicationSuccess = (application: IAllApplication) =>
  action(FETCH_APPLICATION_SUCCESS, { application });
export const fetchApplicationFailed = (errorMessage: string) =>
  action(FETCH_APPLICATION_FAILED, { errorMessage });

export const fetchApplicationAsync =
  (application_number: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchApplicationProgress());

      const res = await api.get(
        `/hr/get-hr-application-form?application_number=${application_number}`
      );
      const data = res.data.data;
      if (data.length > 0) {
        dispatch(fetchApplicationSuccess(data[0]));
      } else {
        dispatch(
          fetchApplicationFailed(
            "Unfortunately, there are no records available at the moment."
          )
        );
      }
    } catch (err: any) {
      dispatch(fetchApplicationFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };
export const upsertApplication = (application: IAllApplication) =>
    action(UPSERT_APPLICATION, {
      application
    });

export const upsertApplicationAysnc =
  (
    application: IAllApplication,
    initialApplication: IAllApplication,
    isUpdate: boolean,
    coverLetter1: any | null,
    coverLetter2: any | null,
    coverLetter3: any | null,
    coverLetter4: any | null,
    coverLetter5: any | null,
    coverLetter6: any | null,
    coverLetter7: any | null,
    coverLetter8: any | null,
    signFile: File | null,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());

      const asPayload_cover = {
        first_name: application.first_name,
        phone: application.phone,
      };

      const CoverLetterPath1 = await uploadFile(
        coverLetter1,
        "HR",
        application.cover_letter_one || "",
        asPayload_cover
      );
      const CoverLetterPath2 = await uploadFile(
        coverLetter2,
        "HR",
        application.cover_letter_two || "",
        asPayload_cover
      );
      const CoverLetterPath3 = await uploadFile(
        coverLetter3,
        "HR",
        application.cover_letter_three || "",
        asPayload_cover
      );
      const CoverLetterPath4 = await uploadFile(
        coverLetter4,
        "HR",
        application.cover_letter_four || "",
        asPayload_cover
      );
      const CoverLetterPath5 = await uploadFile(
        coverLetter5,
        "HR",
        application.cover_letter_five || "",
        asPayload_cover
      );
      const CoverLetterPath6 = await uploadFile(
        coverLetter6,
        "HR",
        application.cover_letter_six || "",
        asPayload_cover
      );
      const CoverLetterPath7 = await uploadFile(
        coverLetter7,
        "HR",
        application.cover_letter_seven || "",
        asPayload_cover
      );
      const CoverLetterPath8 = await uploadFile(
        coverLetter8,
        "HR",
        application.cover_letter_eight || "",
        asPayload_cover
      );

      const signPath = await uploadFile(
        signFile,
        "HR",
        application.sign_attachment || "",
        asPayload_cover
      );

      // const res = await api.post("/hr/edit-hr-application-form", {
      //   ...application,
      //   cover_letter_one: CoverLetterPath1,
      //   cover_letter_two: CoverLetterPath2,
      //   cover_letter_three: CoverLetterPath3,
      //   cover_letter_four: CoverLetterPath4,
      //   cover_letter_five: CoverLetterPath5,
      //   cover_letter_six: CoverLetterPath6,
      //   cover_letter_seven: CoverLetterPath7,
      //   cover_letter_eight: CoverLetterPath8,
      //   sign_attachment: signPath
      // });

      const res = await makeApiCall(
        {
          url: "/hr/edit-hr-application-form",
          method: "POST",
          automation: {
            primaryFieldName: "application_number",
            isUpdate: isUpdate,
          },
        },
        initialApplication,
        {
          ...application,
          cover_letter_one: CoverLetterPath1,
          cover_letter_two: CoverLetterPath2,
          cover_letter_three: CoverLetterPath3,
          cover_letter_four: CoverLetterPath4,
          cover_letter_five: CoverLetterPath5,
          cover_letter_six: CoverLetterPath6,
          cover_letter_seven: CoverLetterPath7,
          cover_letter_eight: CoverLetterPath8,
          sign_attachment: signPath
        }
      );
      const data = res.data.data;
      if(data){
        dispatch(upsertApplication(data))
      }
      const message = "Application is saved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_APPLICATION = "CLEAR_APPLICATION";
export const clearApplication = () => action(CLEAR_APPLICATION);

export const FETCH_USER_OFF_BOARDING_PROGRESS =
  "FETCH_USER_OFF_BOARDING_PROGRESS";
export const FETCH_USER_OFF_BOARDING_SUCCESS =
  "FETCH_USER_OFF_BOARDING_SUCCESS";
export const FETCH_USER_OFF_BOARDING_FAILED = "FETCH_USER_OFF_BOARDING_FAILED";

export const fetchUserOffBoardingProgress = () =>
  action(FETCH_USER_OFF_BOARDING_PROGRESS);
export const fetchUserOffBoardingSuccess = (
  userOffBoarding: IUserOffboarding
) => action(FETCH_USER_OFF_BOARDING_SUCCESS, { userOffBoarding });
export const fetchUserOffBoardingFailed = (errorMessage: string) =>
  action(FETCH_USER_OFF_BOARDING_FAILED, { errorMessage });

export const fetchUserOffBoardingAsync =
  (application_number: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchUserOffBoardingProgress());

      const res = await api.get(
        `/hr/get-user-offboarding?value=${application_number}`
      );
      const data = res.data.data;
      if (data.length > 0) {
        dispatch(fetchUserOffBoardingSuccess(data[0]));
      } else {
        dispatch(
          fetchUserOffBoardingFailed(
            "Unfortunately, there are no records available at the moment."
          )
        );
      }
    } catch (err: any) {
      dispatch(fetchUserOffBoardingFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const upsertUserOffBoardingAysnc =
  (
    userOffBoarding: IUserOffboarding,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post("/hr/edit-user-offboarding", userOffBoarding);
      const message = "User Off Boarded successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const FETCH_USER_ON_BOARDING_PROGRESS =
  "FETCH_USER_ON_BOARDING_PROGRESS";
export const FETCH_USER_ON_BOARDING_SUCCESS = "FETCH_USER_ON_BOARDING_SUCCESS";
export const FETCH_USER_ON_BOARDING_FAILED = "FETCH_USER_ON_BOARDING_FAILED";

export const fetchUserOnBoardingProgress = () =>
  action(FETCH_USER_ON_BOARDING_PROGRESS);
export const fetchUserOnBoardingSuccess = (userOnBoarding: IUserOnboarding) =>
  action(FETCH_USER_ON_BOARDING_SUCCESS, { userOnBoarding });
export const fetchUserOnBoardingFailed = (errorMessage: string) =>
  action(FETCH_USER_ON_BOARDING_FAILED, { errorMessage });

export const fetchUserOnBoardingAsync =
  (application_number: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchUserOnBoardingProgress());

      const res = await api.get(
        `/hr/get-onboarding-checklist?application_number=${application_number}`
      );
      const data = res.data.data;
      if (data.length > 0) {
        dispatch(fetchUserOnBoardingSuccess(data[0]));
      } else {
        dispatch(
          fetchUserOnBoardingFailed(
            "Unfortunately, there are no records available at the moment."
          )
        );
      }
    } catch (err: any) {
      dispatch(fetchUserOnBoardingFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const upsertUserOnBoardingAysnc =
  (
    userOnBoarding: IUserOnboarding,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post("/hr/edit-onboarding-checklist", userOnBoarding);
      const message = "User On Boarded successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const FETCH_REQUEST_FORM_LIST_PROGRESS =
  "FETCH_REQUEST_FORM_LIST_PROGRESS";
export const FETCH_REQUEST_FORM_LIST_SUCCESS =
  "FETCH_REQUEST_FORM_LIST_SUCCESS";
export const FETCH_REQUEST_FORM_LIST_FAILED = "FETCH_REQUEST_FORM_LIST_FAILED";

export const fetchRequestFormListProgress = () =>
  action(FETCH_REQUEST_FORM_LIST_PROGRESS);
export const fetchRequestFormListSuccess = (list: IHrRequestFormDialog[]) =>
  action(FETCH_REQUEST_FORM_LIST_SUCCESS, { list });
export const fetchRequestFormListFailed = (errorMessage: string) =>
  action(FETCH_REQUEST_FORM_LIST_FAILED, { errorMessage });

export const fetchRequestFormListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchRequestFormListProgress());

      let finalUrl = `/hr/get-user-request?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (searchValue.length > 0) {
        finalUrl = `/hr/get-user-request?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }

      const response = await api.get(finalUrl);
      const data = response.data.data;
      if (data) {
        dispatch(fetchRequestFormListSuccess(data));
      } else {
        dispatch(
          fetchRequestFormListFailed(
            "Unfortunately, there are no records available at the moment."
          )
        );
      }
    } catch (err: any) {
      dispatch(fetchRequestFormListFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const fetchAddRequestFormAsync =
  (
    data: IHrRequestFormDialog,
    initialData: IHrRequestFormDialog,
    isUpdate: boolean,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await makeApiCall(
        {
          url: "/hr/edit-user-request",
          method: "POST",
          automation: {
            primaryFieldName: "user_request_code",
            isUpdate: isUpdate,
          },
        },
        initialData,
        data
      );
      const message = "Request Form added successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };
